document.addEventListener("DOMContentLoaded", async () => {
  const wrapper = document.querySelector(".product-navigation");
  if (!wrapper) return;

  let collection = wrapper.dataset.collectionHandle;
  const currentHandle = wrapper.dataset.productHandle;

  if (!collection) {
    collection = sessionStorage.getItem('last_collection_handle');
  }
  if (!collection) return; // no context at all — leave nav hidden rather than guess wrong

  try {
    const response = await fetch(`/collections/${collection}/products.json?limit=250`);
    const data = await response.json();
    const products = data.products;
    const currentIndex = products.findIndex(p => p.handle === currentHandle);
    if (currentIndex === -1) return;

    const prevBtn = wrapper.querySelector(".product-nav-prev");
    const nextBtn = wrapper.querySelector(".product-nav-next");

    if (currentIndex > 0) {
      prevBtn.href = `/collections/${collection}/products/${products[currentIndex - 1].handle}`;
    } else {
      prevBtn.classList.add("disabled");
    }
    if (currentIndex < products.length - 1) {
      nextBtn.href = `/collections/${collection}/products/${products[currentIndex + 1].handle}`;
    } else {
      nextBtn.classList.add("disabled");
    }
  } catch (error) {
    console.error(error);
  }
});